<template>
  <g id="artist">
    <g>
      <path
        class="cls-11"
        d="M1428.4 934.7h-21v-15a108.3 108.3 0 0121 15zM1450.8 963.1h-15v-21a111.4 111.4 0 0115 21z"
        transform="translate(17)"
      />
      <path
        class="cls-12"
        d="M1435.8 942.1v21h-28.4v-28.4h21a86.1 86.1 0 017.4 7.4z"
        transform="translate(17)"
      />
      <path
        class="cls-4"
        d="M1407.4 919.7v15h-28.5v-25.8a107.6 107.6 0 0128.5 10.8z"
        transform="translate(17)"
      />
      <path
        class="cls-11"
        d="M1378.9 908.9v25.8h-28.4v-28.4h4.4a111 111 0 0124 2.6z"
        transform="translate(17)"
      />
      <path
        class="cls-11"
        transform="translate(2803.3 1897.9) rotate(180)"
        d="M1379 934.7h28.4v28.43H1379z"
      />
      <path
        class="cls-12"
        transform="translate(2746.5 1897.9) rotate(180)"
        d="M1350.5 934.7h28.4v28.43h-28.4z"
      />
      <path class="cls-4" d="M1339.1 906.3h28.4v28.43h-28.4z" />
      <path class="cls-11" d="M1310.7 906.3h28.4v28.43h-28.4z" />
      <path
        class="cls-11"
        transform="translate(2689.6 1897.9) rotate(180)"
        d="M1322.1 934.7h28.4v28.43h-28.4z"
      />
      <path
        class="cls-12"
        transform="translate(2632.8 1897.9) rotate(180)"
        d="M1293.7 934.7h28.4v28.43h-28.4z"
      />
      <path
        class="cls-4"
        d="M1293.7 906.3v28.4h-28.5v-25.8a112.6 112.6 0 0124.1-2.6z"
        transform="translate(17)"
      />
      <path
        class="cls-11"
        d="M1265.2 908.9v25.8h-28.4v-15a108.3 108.3 0 0128.4-10.8z"
        transform="translate(17)"
      />
      <path
        class="cls-11"
        transform="translate(2575.9 1897.9) rotate(180)"
        d="M1265.2 934.7h28.4v28.43h-28.4z"
      />
      <path
        class="cls-12"
        transform="translate(2519 1897.9) rotate(180)"
        d="M1236.8 934.7h28.4v28.43h-28.4z"
      />
      <path
        class="cls-4"
        d="M1236.8 919.7v15h-21a108.3 108.3 0 0121-15z"
        transform="translate(17)"
      />
      <path
        class="cls-11"
        d="M1236.8 934.7v28.4h-28.4v-21a86.1 86.1 0 017.4-7.4z"
        transform="translate(17)"
      />
      <path
        class="cls-12"
        d="M1208.4 942.1v21h-15a107.1 107.1 0 0115-21z"
        transform="translate(17)"
      />
      <path
        class="cls-4"
        d="M1461.6 991.6h-25.8v-28.5h15a107.6 107.6 0 0110.8 28.5z"
        transform="translate(17)"
      />
      <path
        class="cls-11"
        transform="translate(2860.2 1954.7) rotate(180)"
        d="M1407.4 963.1h28.4v28.43h-28.4z"
      />
      <path
        class="cls-11"
        d="M1464.2 1015.6v4.4h-28.4v-28.4h25.8a111.7 111.7 0 012.6 24z"
        transform="translate(17)"
      />
      <path
        class="cls-12"
        transform="translate(2860.2 2011.6) rotate(180)"
        d="M1407.4 991.6h28.4v28.43h-28.4z"
      />
      <path
        class="cls-4"
        transform="translate(2803.3 1954.7) rotate(180)"
        d="M1379 963.1h28.4v28.43H1379z"
      />
      <path
        class="cls-11"
        transform="translate(2746.5 1954.7) rotate(180)"
        d="M1350.5 963.1h28.4v28.43h-28.4z"
      />
      <path
        class="cls-11"
        transform="translate(2803.3 2011.6) rotate(180)"
        d="M1379 991.6h28.4v28.43H1379z"
      />
      <path
        class="cls-12"
        transform="translate(2746.5 2011.6) rotate(180)"
        d="M1350.5 991.6h28.4v28.43h-28.4z"
      />
      <path
        class="cls-4"
        transform="translate(2689.6 1954.7) rotate(180)"
        d="M1322.1 963.1h28.4v28.43h-28.4z"
      />
      <path
        class="cls-11"
        transform="translate(2632.8 1954.7) rotate(180)"
        d="M1293.7 963.1h28.4v28.43h-28.4z"
      />
      <path
        class="cls-11"
        transform="translate(2689.6 2011.6) rotate(180)"
        d="M1322.1 991.6h28.4v28.43h-28.4z"
      />
      <path
        class="cls-12"
        transform="translate(2632.8 2011.6) rotate(180)"
        d="M1293.7 991.6h28.4v28.43h-28.4z"
      />
      <path
        class="cls-4"
        transform="translate(2575.9 1954.7) rotate(180)"
        d="M1265.2 963.1h28.4v28.43h-28.4z"
      />
      <path
        class="cls-11"
        transform="translate(2519 1954.7) rotate(180)"
        d="M1236.8 963.1h28.4v28.43h-28.4z"
      />
      <path
        class="cls-11"
        transform="translate(2575.9 2011.6) rotate(180)"
        d="M1265.2 991.6h28.4v28.43h-28.4z"
      />
      <path
        class="cls-12"
        transform="translate(2519 2011.6) rotate(180)"
        d="M1236.8 991.6h28.4v28.43h-28.4z"
      />
      <path
        class="cls-4"
        transform="translate(2462.2 1954.7) rotate(180)"
        d="M1208.4 963.1h28.4v28.43h-28.4z"
      />
      <path
        class="cls-11"
        d="M1208.4 963.1v28.5h-25.8a107.6 107.6 0 0110.8-28.5z"
        transform="translate(17)"
      />
      <path
        class="cls-11"
        transform="translate(2462.2 2011.6) rotate(180)"
        d="M1208.4 991.6h28.4v28.43h-28.4z"
      />
      <path
        class="cls-12"
        d="M1208.4 991.6v28.4h-28.5v-4.4a111.7 111.7 0 012.7-24z"
        transform="translate(17)"
      />
    </g>
    <path
      class="cls-13"
      d="M1322.1 867.5a71 71 0 00-71.1 71v53.1l71.1-28.5 71.1 28.5v-53.1a71.1 71.1 0 00-71.1-71z"
      transform="translate(17)"
    />
    <path
      class="cls-14"
      d="M1454.1 677.2l-9.9 63.3-121.8 8-121.9-8-9.8-63.3c-10.4-66.3 40.9-126.2 108-126.2h47.3c67.1 0 118.4 59.9 108.1 126.2z"
      transform="translate(17)"
    />
    <g>
      <path
        class="cls-15"
        d="M1215.1 722.7h78.6v56.8h-78.6a28.5 28.5 0 01-28.5-28.4 28.5 28.5 0 0128.5-28.4zM1429.7 722.7h-79.2v56.8h79.2a28.4 28.4 0 0028.4-28.4 28.4 28.4 0 00-28.4-28.4z"
        transform="translate(17)"
      />
    </g>
    <path
      class="cls-15"
      d="M1295.3 862.8h87.5v43.3a43.6 43.6 0 01-43.6 43.6h-.1a43.8 43.8 0 01-43.8-43.8v-43.1z"
    />
    <path
      class="cls-16"
      d="M1229.7 658.2h218.7v122.4a109.2 109.2 0 01-109.2 109.2h-.1a109.4 109.4 0 01-109.4-109.4V658.2z"
    />
    <path
      class="cls-17"
      d="M1339 718.9a21.9 21.9 0 0121.9 21.9V762h-43.7v-21.3a21.8 21.8 0 0121.8-21.8z"
    />
    <path
      class="cls-18"
      d="M1279.4 735.4a13.1 13.1 0 11-13.1-13.1 13.1 13.1 0 0113.1 13.1zM1391 735.4a13.2 13.2 0 11-13.2-13.1 13.2 13.2 0 0113.2 13.1z"
      transform="translate(17)"
    />
    <path
      class="cls-14"
      d="M1323 908.3h-1.8a108.5 108.5 0 01-108.5-108.4 37.9 37.9 0 0137.8-37.9h143.1a37.9 37.9 0 0137.8 37.9A108.4 108.4 0 011323 908.3z"
      transform="translate(17)"
    />
    <path
      class="cls-19"
      d="M1373.6 795.5a50.9 50.9 0 01-2.9 17.2 50.4 50.4 0 01-24.7 28.5l-2 1a52.4 52.4 0 01-43.8 0 13.4 13.4 0 01-2.4-1.2 50.5 50.5 0 01-24.4-28.3 53.5 53.5 0 01-2.8-17.2z"
      transform="translate(17)"
    />
    <path
      class="cls-20"
      d="M1373.6 795.5a50.9 50.9 0 01-2.9 17.2h-97.3a53.5 53.5 0 01-2.8-17.2z"
      transform="translate(17)"
    />
    <path
      class="cls-21"
      d="M1344 842.2a52.4 52.4 0 01-43.8 0 21.9 21.9 0 0143.8 0z"
      transform="translate(17)"
    />
    <path class="cls-14" d="M1258.2 692.6h50.3v13.12h-50.3zM1369.7 692.6h50.3v13.12h-50.3z" />
    <circle class="cls-20" cx="1339.1" cy="991.6" r="8.9" />
  </g>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>